import sdkLoading from "@/components/sdk-ui/sdk-loading/sdk-loading.vue";
import { dispatch } from "@/utils/dispatch";
import { generateId } from "@/utils/generateid";
import Vue from "vue";
import VueContentLoading from "vue-content-loading";
import VueI18n from "vue-i18n";
import Notifications from "vue-notification";
import VueTheMask from "vue-the-mask";
import vPaginate from "vuejs-paginate";
import App from "./app.vue";
import "./plugins/element/element.js";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { getCookie } from "./utils/cookie";
import VueSweetalert2 from "vue-sweetalert2";
import InitLog from "@mv/flow-shared-utils/functions/log";
import TreeView from "vue-json-tree-view";
import SdkGridList from "./components/sdk-ui/sdk-grid-list/sdk-grid-list.vue";
import SdkGridListItem from "./components/sdk-ui/sdk-grid-list-item/sdk-grid-list-item.vue";
import vueDebounce from "vue-debounce";

import "sweetalert2/dist/sweetalert2.min.css";
const { name, version } = require("../package.json");

Vue.use(VueSweetalert2);
Vue.use(Notifications);
Vue.use(VueI18n);
Vue.use(VueTheMask);
Vue.use(TreeView);
Vue.use(vueDebounce, {
  defaultTime: "600ms",
});
Vue.prototype.$dispatch = dispatch;
Vue.prototype.$generateId = generateId;
Vue.component("v-pagination", vPaginate);
Vue.component("sdk-loading", sdkLoading);
Vue.component("vue-content-loading", VueContentLoading);

Vue.component("sdk-grid-list", SdkGridList);
Vue.component("sdk-grid-list-item", SdkGridListItem);

const messages = {
  pt_BR: require("./i18n/pt_BR.json"),
  es_CL: require("./i18n/es_CL.json"),
  es_DO: require("./i18n/es_DO.json"),
  es_EC: require("./i18n/es_EC.json"),
  es_ES: require("./i18n/es_ES.json"),
  es_MX: require("./i18n/es_MX.json"),
  es_PA: require("./i18n/es_PA.json"),
  es_PE: require("./i18n/es_PE.json"),
  es_UY: require("./i18n/es_UY.json"),
};

const language = getCookie("language");

InitLog({ name, version });

const i18n = new VueI18n({
  locale: language,
  fallbackLocale: "pt_BR",
  messages,
});

Vue.config.productionTip = false;

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title ? to.meta.title : "Flow Modeler";
  });
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
